import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchVehAudiReport = (type, dat, line) => apiActionCreator({
  'endpoint': `/vehAudi/${type}/type/${dat}/dat/${line}/line`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_VEH_AUDI_REPORT,
    ActionTypes.FETCHED_VEH_AUDI_REPORT,
    [
      ActionTypes.FETCHED_VEH_AUDI_REPORT_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchVehAudiSetReport = (type, dat) => apiActionCreator({
  'endpoint': `/vehAudi/set/${type}/type/${dat}/dat`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_VEH_AUDI_SET_REPORT,
    ActionTypes.FETCHED_VEH_AUDI_SET_REPORT,
    [
      ActionTypes.FETCHED_VEH_AUDI_SET_REPORT_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const downloadVehAudiReportFile = (type, dat) => apiActionCreator({
  'endpoint': `/vehAudi/excel/${type}/type/${dat}/dat`,
  'authenticated': true,
  'types': [
    ActionTypes.DOWNLOADING_VEH_AUDI_REPORT_LIST_FILE,
    ActionTypes.DOWNLOADED_VEH_AUDI_REPORT_LIST_FILE,
    [
      ActionTypes.DOWNLOADED_VEH_AUDI_REPORT_LIST_FILE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const downloadVehAudiSetReportFile = (type, dat) => apiActionCreator({
  'endpoint': `/vehAudi/set/excel/${type}/type/${dat}/dat`,
  'authenticated': true,
  'types': [
    ActionTypes.DOWNLOADING_VEH_AUDI_SET_REPORT_FILE,
    ActionTypes.DOWNLOADED_VEH_AUDI_SET_REPORT_FILE,
    [
      ActionTypes.DOWNLOADED_VEH_AUDI_SET_REPORT_FILE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const deleteVehAudiReport = (data) => ({
  'type': ActionTypes.DELETE_VEH_AUDI_REPORT,
});

export const changeVehAudiPage = (value) => ({
  'type': ActionTypes.CHANGE_VEH_AUDI_REPORT_LIST_PAGE,
  'payload': value,
});

export const changeVehAudiPageSize = (value) => ({
  'type': ActionTypes.CHANGE_VEH_AUDI_REPORT_LIST_PAGE_SIZE,
  'payload': value,
});

export const deleteUrlVehAudi = (data) => ({
  'type': ActionTypes.DELETE_URL_AUDI,
});

export const fetchVehAudiInf = (type, dat, line) => apiActionCreator({
  'endpoint': `/vehAudi/veh-inf/${type}/type/${dat}/dat/${line}/line`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_VEH_AUDI_INF,
    ActionTypes.FETCHED_VEH_AUDI_INF,
    [
      ActionTypes.FETCHED_VEH_AUDI_INF_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
